export const DAY_NAMES = {
    pl: {
        short: ['Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.', 'Niedz.'],
        full: [
            'Poniedziałek',
            'Wtorek',
            'Środa',
            'Czwartek',
            'Piątek',
            'Sobota',
            'Niedziela',
        ],
    },
    en: {
        short: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        full: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ],
    },
    uk: {
        short: ['Пн.', 'Вт.', 'Ср.', 'Чт.', ' Пт.', 'Сб.', 'Нд.'],
        full: [
            'Понеділок',
            'Вівторок',
            'Середа',
            'Четвер',
            'П’ятниця',
            'Субота',
            'Неділя',
        ],
    },
}
